import { createRoute,lazyRouteComponent } from '@tanstack/react-router'

import type { RegisterSearch } from './register'
import { rootRoute } from './root'

const TJRegister = lazyRouteComponent(() => import('../pages/tj-register'))

export const tjRegisterRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/tj-register',
  component: TJRegister,
  validateSearch: (search: Record<string, unknown>): RegisterSearch => {
    return search
  },
})
